import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';
import { completeRecurringTask, type CompleteRecurringPayload } from '../api/tasks';

export function useCompleteRecurringTask(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ taskId, payload }: { taskId: string; payload: CompleteRecurringPayload }) =>
      completeRecurringTask(taskId, payload),
    onSuccess: async () => {
      notification.success({ message: 'Recurring task completed successfully' });
      await queryClient.invalidateQueries({ queryKey: ['taskItems'] });
      await queryClient.invalidateQueries({ queryKey: ['taskItem'] });
      await queryClient.invalidateQueries({ queryKey: ['task-dashboard'] });
      onSuccess?.();
    },
    onError: () => {
      notification.error({ message: 'Failed to complete recurring task' });
    },
  });
}
